export default __webpack_public_path__ + "static/media/location-green-icon.ec6de638.svg";